// 注意: 出码引擎注入的临时变量默认都以 "__$$" 开头，禁止在搭建的代码中直接访问。
// 例外：react 框架的导出名和各种组件名除外。
import React from "react";
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';


import { Container } from "@ifeng-fe/lowcode_basic/src/components/layout/Container/index.tsx";

import { Video_ip } from "@ifeng-fe/lowcode_business/src/components/video/Video_ip/index.tsx";

import { ImageLink } from "@ifeng-fe/lowcode_basic/src/components/popular/ImageLink/index.tsx";

import { Swiper_1 } from "@ifeng-fe/lowcode_basic/src/components/Swiper/Swiper_1/index.tsx";

import { NewsList_11 } from "@ifeng-fe/lowcode_basic/src/components/NewsList/NewsList_11/index.tsx";

import { Comment } from "@ifeng-fe/lowcode_basic/src/components/popular/Comment/index.tsx";

import utils from "../../utils";

import "./index.css";

class Layout$$Page extends React.Component {
  _context = this;

  constructor(props, context) {
    super(props);

    this.utils = utils;

    this.state = {};
  }

  $ = () => null;

  $$ = () => [];

  componentDidMount() {}

  render() {
    const __$$context = this._context || this;
    const { state } = __$$context;
    return (
      <div
        nodeId="node_dockcviv8fo1"
        style={{
          backgroundImage:
            "url(https://x0.ifengimg.com/ucms/2024_34/C55D280F3577EDD68EF5B4BBA343B46D0E8F6554_size1543_w1920_h4800.jpg)",
          paddingTop: "825px",
          paddingBottom: "125px",
          backgroundPositionX: "center",
          backgroundPositionY: "top",
          backgroundRepeat: "no-repeat",
          backgroundSize: "1920px auto",
          maxWidth: "1920px",
        }}
      >
        <Container
          width={1060}
          isCenter={true}
          nodeId="node_ocm00pi4qc1"
          hoverStyle=""
          style={{
            padding: "38px 30px 40px",
            background: "rgba(247, 235, 206, 0.5)",
          }}
        >
          <Container isCenter={true} nodeId="node_ocm00o3cms1" hoverStyle="">
            <Video_ip
              tabText1=""
              videoChip1={{
                $data: true,
                id: "288432",
                type: "recommend",
                title: "选项卡1-数据",
                format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                default: { type: "recommend", id: "285981" },
                uuid: "8b50999f",
              }}
              tabText2=""
              videoChip2={{
                $data: true,
                id: 285984,
                type: "recommend",
                title: "选项卡2-数据",
                format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                default: { type: "recommend", id: "285982" },
                uuid: "97a3d508",
              }}
              headerImageHeight={28}
              unActiveTabStyle={{
                fontSize: "24px",
                color: "dab579",
                borderColor: "#dab579",
                borderStyle: "solid",
                borderWidth: 2,
                paddingTop: 8,
                paddingRight: 11,
                paddingBottom: 9,
                paddingLeft: 12,
              }}
              activeTabStyle={{ backgroundColor: "#DAB579", color: "#34261E" }}
              deviderColor="#ffffff"
              deviderMargin={20}
              videoWidth={667}
              videoHeight={376}
              videoAutoPlay={true}
              videoControls={true}
              feedImageBorderColor="linear-gradient(125deg, #513500, #513500)"
              fontColor="#513500"
              lineColor="#7C5100"
              selectFontColor="#925F00"
              hoverColor="#925F00"
              nodeId="node_ocm00o3cms2"
              hoverStyle=""
              headerStyle={{
                borderBottomStyle: "solid",
                borderBottomWidth: "1px",
                borderBottomColor: "#7C5100",
                height: "56px",
                textIndent: "20px",
              }}
              headerImage="https://x0.ifengimg.com/ucms/2024_34/FD9EAB3AE167837B40D115DCC575696AA848289F_size5_w420_h28.png"
            />
          </Container>
          <Container
            isCenter={true}
            nodeId="node_ocm00o3cms3"
            hoverStyle=""
            style={{}}
          >
            <ImageLink
              url=""
              isBlock={false}
              width={689}
              height={67}
              objectFit=""
              nodeId="node_ocm00o3cms4"
              image="https://x0.ifengimg.com/ucms/2024_34/8E412BD2B4D7722E918EEFBC7525E7C056CE0288_size8_w689_h67.png"
              hoverStyle=""
              style={{ margin: "92px auto 11px", display: "block" }}
            />
            <Container
              isCenter={true}
              nodeId="node_ocm00s4ha41"
              hoverStyle=""
              style={{
                backgroundImage:
                  "url(https://x0.ifengimg.com/ucms/2024_34/41F9699AEB302ED45F23F770CE998376760EFA00_size589_w892_h585.png)",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "892px 585px",
                padding: "48px 0 37px",
              }}
            >
              <Container
                isCenter={true}
                nodeId="node_ocm00o3cms6"
                hoverStyle=""
                width={750}
                style={{
                  paddingTop: "5px",
                  paddingRight: "5px",
                  paddingBottom: "5px",
                  paddingLeft: "5px",
                  backgroundColor: "#616F85",
                }}
              >
                <Swiper_1
                  swiperChip={{
                    $data: true,
                    id: "288433",
                    type: "recommend",
                    title: "轮播图内容",
                    default: { type: "recommend", id: "285915" },
                    uuid: "405aa9f7",
                  }}
                  height={500}
                  isHasNav={true}
                  leftNavImage="https://x0.ifengimg.com/ucms/2024_34/08B67F4851B6BA457C18386178E377972F19552B_size1_w47_h88.png"
                  rightNavImage="https://x0.ifengimg.com/ucms/2024_34/629072AD27D254FA6F4EED30AB7AE7522E763869_size1_w47_h88.png"
                  navWidth={47}
                  navHeight={88}
                  navY={206}
                  navX={-130}
                  isAutoPlay={true}
                  autoSpeed={3000}
                  isHasTitle={true}
                  titleHeight={70}
                  titleStyle={{
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    color: "#fff",
                    fontSize: "24px",
                    paddingLeft: "8px",
                    textAlign: "center",
                    fontFamily: "PingFang SC",
                  }}
                  isHasPagination={false}
                  paginationPosition="titleRight"
                  paginationNormalStyle={{
                    marginRight: "6px",
                    width: "14px",
                    height: "14px",
                    backgroundColor: "#d8eaf7",
                    borderTopLeftRadius: "50px",
                    borderTopRightRadius: "50px",
                    borderBottomLeftRadius: "50px",
                    borderBottomRightRadius: "50px",
                  }}
                  paginationActiveStyle={{ backgroundColor: "#70c6fb" }}
                  paginationTotalStyle={{ marginRight: "10px" }}
                  nodeId="node_ocm00o3cms5"
                  loop={true}
                  hoverStyle=""
                  leftNavHoverImage="https://x0.ifengimg.com/ucms/2024_34/05703F986A41474B210E659C145D1814C310FD78_size1_w47_h88.png"
                  rightNavHoverImage="https://x0.ifengimg.com/ucms/2024_34/3DEE2659A259A08F56C4DC7DC310DBDAD7141161_size1_w47_h88.png"
                />
              </Container>
            </Container>
          </Container>
          <Container isCenter={true} nodeId="node_ocm00o3cms7">
            <ImageLink
              url=""
              isBlock={false}
              width={689}
              height={67}
              objectFit=""
              nodeId="node_ocm00o3cms8"
              image="https://x0.ifengimg.com/ucms/2024_34/B298845A4B6C627336E907638BA4F9E0A23BC02A_size8_w689_h67.png"
              hoverStyle=""
              style={{ margin: "50px auto 40px", display: "block" }}
            />
            <NewsList_11
              newsChip={{
                $data: true,
                id: "288434",
                type: "recommend",
                title: "新闻内容",
                format: {
                  filter: [
                    "thumbnails",
                    "title",
                    "type",
                    "url",
                    "base62Id",
                    "summary",
                    "children",
                    "position",
                    "newsTime",
                  ],
                },
                default: { type: "recommend", id: "285873" },
                uuid: "5118e6b4",
              }}
              colNum={1}
              colPadding={35}
              showColBorder={true}
              itemStyle={{
                paddingTop: "15px",
                paddingBottom: "15px",
                fontWeight: "400",
                borderBottomWidth: "1px",
                borderBottomStyle: "solid",
                borderBottomColor: "#7C5100",
              }}
              itemAlignCenter={false}
              itemHoverColor="#936000"
              showThumbnail={true}
              thumbnailWidth={144}
              thumbnailHeight={96}
              showThumbnailHoverScale={true}
              titleStyle={{
                color: "#513500",
                lineHeight: "30px",
                height: "72px",
                fontSize: "24px",
              }}
              showSummary={false}
              summaryStyle={{
                color: "#666666",
                fontSize: "14px",
                lineHeight: "24px",
              }}
              moreText="[详细]"
              moreStyle={{ color: "#ba2636" }}
              showTime={true}
              timeStyle={{
                color: "#735D33",
                fontSize: "16px",
                lineHeight: "24px",
              }}
              nodeId="node_ocm00o3cms9"
              hoverStyle=""
              style={{
                maxHeight: "757px",
                cursor: "pointer",
                paddingRight: "15px",
              }}
              thumbnailStyle={{
                paddingTop: "3px",
                paddingRight: "3px",
                paddingBottom: "3px",
                paddingLeft: "3px",
                backgroundColor: "#616F85",
              }}
            />
          </Container>
          <Container isCenter={true} nodeId="node_ocm00o3cmsa" hoverStyle="">
            <ImageLink
              url=""
              isBlock={false}
              width={689}
              height={67}
              objectFit=""
              nodeId="node_ocm00o3cmsb"
              image="https://x0.ifengimg.com/ucms/2024_34/1BAE1A51F831676091430AD309073B90E4463776_size7_w689_h67.png"
              hoverStyle=""
              style={{ margin: "106px auto 42px", display: "block" }}
            />
            <Container
              isCenter={true}
              nodeId="node_ocm00w01be2"
              hoverStyle=""
              style={{ overflow: "hidden", height: "222px" }}
            >
              <Container
                isCenter={true}
                nodeId="node_ocm00w01be6"
                hoverStyle=""
                style={{
                  width: "145px",
                  height: "222px",
                  float: "left",
                  marginLeft: "40px",
                  textAlign: "center",
                }}
              >
                <ImageLink
                  image="https://x0.ifengimg.com/ucms/2024_34/668D1F9F7784D5033601058F2DC5C73F2F637903_size33_w112_h222.png"
                  url=""
                  isBlock={false}
                  width={112}
                  height={222}
                  objectFit=""
                  nodeId="node_ocm00w01be3"
                  hoverStyle=""
                  style={{}}
                />
              </Container>
              <Container
                isCenter={true}
                nodeId="node_ocm026ead11"
                hoverStyle=""
                style={{
                  width: "257px",
                  height: "125px",
                  float: "left",
                  marginLeft: "60px",
                  marginTop: "48px",
                }}
              >
                <ImageLink
                  image="https://x0.ifengimg.com/ucms/2024_34/A126815344A19B218733BF67F0DD2CC5323A49B1_size7_w257_h125.png"
                  url="https://v.ifeng.com/loc/jiushiju"
                  isBlock={false}
                  width={257}
                  height={125}
                  objectFit=""
                  nodeId="node_ocm00w01be4"
                  hoverStyle={{}}
                  style={{ width: "257px", height: "125px", display: "block" }}
                />
              </Container>
              <Container
                isCenter={true}
                nodeId="node_ocm00w01be8"
                hoverStyle={{}}
                style={{
                  width: "257px",
                  height: "125px",
                  float: "left",
                  marginLeft: "106px",
                  marginTop: "48px",
                }}
              >
                <ImageLink
                  image="https://x0.ifengimg.com/ucms/2024_34/98BF92F5E585BE4FD1CC3BD2A9908614CC95E3CA_size7_w257_h125.png"
                  url="https://v.ifeng.com/loc/jiushiju23"
                  isBlock={false}
                  width={275}
                  height={125}
                  objectFit=""
                  nodeId="node_ocm00w01be5"
                  hoverStyle={{}}
                  style={{}}
                />
              </Container>
            </Container>
          </Container>
          <Container isCenter={true} nodeId="node_ocm00o3cmsc" hoverStyle="">
            <ImageLink
              url=""
              isBlock={false}
              width={689}
              height={67}
              objectFit=""
              nodeId="node_ocm00o3cmsd"
              image="https://x0.ifengimg.com/ucms/2024_34/9B941CA4539963467541AE8BF002B1147B75A1A8_size8_w689_h67.png"
              hoverStyle=""
              style={{ margin: "89px auto 63px", display: "block" }}
            />
            <ImageLink
              url=""
              isBlock={false}
              width={353}
              height={103}
              objectFit=""
              nodeId="node_ocm00o3cmse"
              image="https://x0.ifengimg.com/ucms/2024_34/248F47345C37FE917E1BE5DA0DA5EBEA244A3748_size16_w353_h103.png"
              hoverStyle=""
              style={{ display: "block", margin: "0 auto" }}
            />
          </Container>
          <Container isCenter={true} nodeId="node_ocm00o3cmsf">
            <ImageLink
              url=""
              isBlock={false}
              width={689}
              height={67}
              objectFit=""
              nodeId="node_ocm00o3cmsg"
              image="https://x0.ifengimg.com/ucms/2024_34/BF0F1A7B1ECC77A4FD98CE61E04195FC57EDE5A3_size8_w689_h67.png"
              hoverStyle=""
              style={{ margin: "94px auto 69px", display: "block" }}
            />
            <Comment
              url="https://jiu.ifeng.com/loc/jiushiju24"
              title="中华酒事局2024"
              nodeId="node_ocm00p4ouu1"
              hoverStyle=""
            />
          </Container>
        </Container>
      <ChipEdit transform={chipDataTransform} />
</div>
    );
  }
}

export default Layout$$Page;

function __$$eval(expr) {
  try {
    return expr();
  } catch (error) {}
}

function __$$evalArray(expr) {
  const res = __$$eval(expr);
  return Array.isArray(res) ? res : [];
}

function __$$createChildContext(oldContext, ext) {
  const childContext = {
    ...oldContext,
    ...ext,
  };
  childContext.__proto__ = oldContext;
  return childContext;
}
